import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';

function UserInvitationView(props) {
  const {user} = props;

  return (
    <div className="box p-3">
      <div className="d-flex justify-content-between">
        <div className="flex-container">
          <strong>{user.firstName}&nbsp;{user.lastName}</strong>
          <span>{user.email}</span>
        </div>
        <button
          type="button"
          className="large primary"
          onClick={props.onAddUser}
        >
          <Translate value="action.invite"/>
        </button>
      </div>
    </div>
  );
}

UserInvitationView.propTypes = {
  user: PropTypes.object.isRequired,
  onAddUser: PropTypes.func.isRequired
};

export default UserInvitationView;
